module.exports = __webpack_public_path__ + "img/logo_extended_orange.76d6b556.svg";